// extracted by mini-css-extract-plugin
module.exports = {"highlight":"VocabularWord_highlight__2NLuS","popup":"VocabularWord_popup__2a2HK","popupBackground":"VocabularWord_popupBackground__3SW24","word":"VocabularWord_word__NLR8n"};